import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { ApiResponse } from 'src/app/models/IApiResponse';
import { Observable, catchError } from 'rxjs';
import { ConfigErrorHandler } from 'src/app/shared/config.errorhandler';

@Injectable({
  providedIn: 'root'
})
export class AddPaymentsService {
  private baseURL = environment.apiURL;
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

  constructor(
    private http: HttpClient,
    private errorHandler: ConfigErrorHandler
  ) { }

   /**
   * Get unpaid radiation charges
   * @returns Array
   */
  fetchUnpaidRadiationCharges(): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/transactions/get-unpaid-radiation-charges`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Post radiation payment
   * @param payload
   * @returns array
   */
  postRadiationPayment(payload:any):Observable<any>{

    let apiURL:string=`${this.baseURL}/v1/transactions/pay-radiation-charges`;

      return this.http.post(apiURL,payload, { headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get unpaid IDF charges
   * @returns Array
   */
  fetchUnpaidIdfCharges(): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/transactions/get-unpaid-idf-charges`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Post IDF payment
   * @param payload
   * @returns array
   */
  postIdfPayment(payload:any):Observable<any>{

    let apiURL:string=`${this.baseURL}/v1/transactions/pay-idf-charges`;

      return this.http.post(apiURL,payload, { headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Get unpaid NEMA charges
   * @returns Array
   */
  fetchUnpaidNemaCharges(): Observable<ApiResponse>{

    let apiURL:string=`${this.baseURL}/v1/transactions/get-unpaid-nema-charges`;

    return this.http.get<ApiResponse>(apiURL,{ headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }

  /**
   * Post NEMA payment
   * @param payload
   * @returns array
   */
  postNemaPayment(payload:any):Observable<any>{

    let apiURL:string=`${this.baseURL}/v1/transactions/pay-nema-charges`;

      return this.http.post(apiURL,payload, { headers: this.headers }).pipe(catchError(this.errorHandler.handleError));
  }
}
